import "./Footer.scss";

import { ReactComponent as TelegramIcon } from "../../assets/icons/Telegram.svg";
import { ReactComponent as XLogo } from "../../assets/icons/XLogo.svg";
import { ReactComponent as MediumIcon } from "../../assets/icons/Medium.svg";
import { ReactComponent as DexToolsIcon } from "../../assets/icons/DexTools.svg";
import { ReactComponent as GitbookIcon } from "../../assets/icons/Gitbook.svg";

import LightFooter from "../../assets/images/light-footer.svg";
import FooterLeft from "../../assets/images/footer-left.png";
import FooterRight from "../../assets/images/footer-right.png";

export default function Footer() {
	return (
		<div className="footer" id="footer">
			<div className="decoration light-footer">
				<img src={LightFooter} alt="Light Footer" />
			</div>
			
			<div className="footer-content-wrap content-wrapper-lg">
				<img
					src={FooterLeft}
					alt="Footer Left"
					className="img-footer-left decoration"
				/>
				<img
					src={FooterRight}
					alt="Footer Right"
					className="img-footer-right decoration"
				/>

				<div className="footer-content">
					<div className="footer-links-wrapper">
						<ul className="footer-links">
							<li>
								<div className="footer-link">
									<a href="https://syntraa.gitbook.io/storm">
										<GitbookIcon className="footer-link-icon" />
									</a>
								</div>
							</li>
							<li>
								<div className="footer-link">
									<a href="#-">
										<XLogo className="footer-link-icon" />
									</a>
								</div>
							</li>
							<li>
								<div className="footer-link">
									<a href="#-">
										<TelegramIcon className="footer-link-icon" />
									</a>
								</div>
							</li>
							<li>
								<div className="footer-link">
									<a href="#-">
										<DexToolsIcon className="footer-link-icon" />
									</a>
								</div>
							</li>
							<li>
								<div className="footer-link">
									<a href="#-">
										<MediumIcon className="footer-link-icon" />
									</a>
								</div>
							</li>
						</ul>
					</div>

					<div className="footer-copyright">
						<p>
							Copyright © 2024 - 2025 StormAI®. All rights
							reserved.
						</p>
					</div>
				</div>
			</div>
		</div>
	);
}
